<template>
  <div>
    <div class="x">
      <el-dialog :visible.sync="dialogVisible" width="70%" :before-close="closeDialog">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">纳排标准-{{ QName }}</span>
        </div>
        <!-- <div style="margin-bottom: 20px" class="div_select"></div> -->
        <!-- <div class="btn">
          <button @click="bindDialog = false">取消</button>
          <button type="primary" @click="bindAdd">确定</button>
        </div> -->
        <div>
          <!-- <div class="condition">纳排标准</div> -->
          <div class="form">
            <div class="nbSearch">
              <div class="nbSearch_child" v-for="(item, index) in nbForm" :key="index">
                <!-- 第一条显示 -->
                <div style="width: 100px; text-align: right; color: #666" v-if="index == 0">查询条件</div>
                <!-- 后面 是  或 和 与 -->
                <el-select v-if="index != 0" class="opAndOr" v-model="item.SelectType" placeholder="请选择">
                  <el-option v-for="itemc in opAndOr" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>
                <!-- 真正的开始 后端获取options -->
                <el-select v-model="item.DataMappingId" placeholder="请选择">
                  <el-option v-for="itemc in options" :key="itemc.Id" :label="itemc.Name" :value="itemc.Id"></el-option>
                </el-select>
                <!-- 通过关系切换状态 /// 条件类型 0 首次  1末次 2 包含 3 未包含 4 等于 5 不等于
/// 6 大于 7 小于 8 值范围 -->
                <el-select @change="changeRelation(item, index)" v-model="item.ConditionalType" placeholder="请选择查询关系">
                  <el-option v-for="itemc in opRelations" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>

                <!--  状态是 8 的时候考虑阈值范围 -->
                <el-input class="inputChose" v-if="item.ConditionalType == 8" placeholder="最大为" v-model="item.MaxVaule">
                  <div slot="suffix" class="flexAll_end">(最大值)</div>
                </el-input>
                <el-input class="inputChose" v-if="item.ConditionalType == 8" placseholder="最小为" v-model="item.MinVaule">
                  <div slot="suffix" class="flexAll_end">(最小值)</div>
                </el-input>
                <!-- 显示文本   为8加个插槽 v-if="item.ConditionalType != 2 && item.ConditionalType != 3 && item.ConditionalType != 8" -->
                <el-input class="inputChose" v-model="item.Vaule" placeholder="请输入">
                  <div v-if="item.ConditionalType == 8" slot="suffix" class="flexAll_end">(倍数)</div>
                </el-input>
                <!--正常 之前之后 -->
                <!-- <el-select @change="timeChange(item, index)" v-model="item.EventConditional" placeholder="时间节点">
                  <el-option v-for="itemc in optionsTime" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>-->
                <!-- 之前之后多少天 -->
                <!--
                <el-input class="inputChose" v-if="item.EventConditional != 0" placseholder="时间单位(天)" v-model="item.EventDay">
                  <div slot="suffix" class="flexAll_end">(天)</div>
                </el-input>
                -->
                <!-- 换行 -->
                <div v-if="item.EventConditional != 0" style="width: 100%; height: 15px"></div>
                <!-- 后端获取options  第二行内容-->
                <div v-if="item.EventConditional != 0" style="width: 110px; height: 15px"></div>
                <el-select v-if="item.EventConditional != 0" v-model="item.EventDataMappingId" placeholder="请选择">
                  <el-option v-for="itemc in options" :key="itemc.Id" :label="itemc.Name" :value="itemc.Id"></el-option>
                </el-select>
                <el-select v-if="item.EventConditional != 0" @change="changeRelations(item, index)" v-model="item.EventConditionalType" placeholder="请选择查询关系">
                  <el-option v-for="itemc in opRelations2" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>
                <el-input v-if="item.EventConditional != 0" class="inputChose" v-model="item.EventVaule" placeholder="请输入">
                  <div v-if="item.EventConditionalType == 8" slot="suffix" class="flexAll_end">(倍数)</div>
                </el-input>

                <!--  -->
                <!-- 右侧按钮 -->
                <div class="flexAll">
                  <div style="margin-right: 10px" @click="toAdd(item, index)">
                    <i class="el-icon-circle-plus-outline iconRight"></i>
                    <span>添加</span>
                  </div>
                  <div @click="toDel(item, index)" v-if="index != 0">
                    <i class="el-icon-remove-outline iconRight"></i>
                    <span>删除</span>
                    <!-- <span v-if="index == 0">清空</span> -->
                  </div>
                  <div v-if="index == 0" @click="toClear">
                    <i class="el-icon-remove-outline iconRight"></i>
                    <span>清空</span>
                  </div>
                </div>
              </div>
              <!-- 内容 -->
              <div style="display: flex; margin-top: 50px">
                <div style="margin-left: 40px">纳排标准：</div>
                <el-input :autosize="{ minRows: 2, maxRows: 10 }" show-word-limit maxlength="1000" style="width: 75%; font-size: 14px" v-model="x" type="textarea" placeholder=""></el-input>
              </div>
            </div>
          </div>
          <!-- 高级查询搜索 -->
          <div style="width: 100%; display: flex; justify-content: flex-end; margin-bottom: 0px">
            <el-button type="primary" @click="onSave" class="czhi">
              <!-- <img src="../../assets/image/icon/FillIn.png" alt style="width: 14px; height: 14px" /> -->
              保存
            </el-button>
            <el-button style="margin-right: 100px" @click="onRestFz" class="czhi">
              <!-- <img src="../../assets/image/icon/czhi.png" alt style="width: 14px; height: 14px" /> -->
              重置
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import naPai from '@/api/naPai';
import smartSearch from '@/api/smartSearch.js';
import { opAndOr, opRelations, opRelations2, options, optionsTime } from '@/utils/dictionary.js';
export default {
  name: '',
  components: {},
  props: {
    Qid: {
      type: String,
      default: ''
    },
    QName: {
      type: String,
      default: ''
    },
    ProjectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      x: '',
      dialogVisible: false,
      pageSet: {
        key: '',
        page: 1,
        rows: 200
      },
      nbForm: [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ],
      options: [],
      opRelations: opRelations,
      opRelations2: opRelations2,
      opAndOr: opAndOr,
      optionsTime: optionsTime
    };
  },
  computed: {},
  created() {
    this.getList();
    this.getData();
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog', false);
    },
    bindAdd() {},
    toClear() {
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
      console.log(123456);
    },
    getData() {
      const params = {
        ProjectId: this.ProjectId,
        Qid: this.Qid
      };
      console.log(params, 9898);
      naPai.getList(params).then(e => {
        console.log(e);
        if (e.data.ProjectRuleList.length == 0) {
          this.nbForm = [
            {
              ConditionalType: '',
              Vaule: '',
              EventConditional: 0
            }
          ];
        } else {
          this.x = e.data.Remarks;
          this.nbForm = e.data.ProjectRuleList;
        }
        console.log(e);
      });
    },
    onSave() {
      const params = {
        ProjectId: this.ProjectId,
        Qid: this.Qid,
        projectRuleEntity: this.nbForm,
        Remarks: this.x
      };
      // console.log(params);
      console.log(params, 777);
      // this.nbForm.forEach(e => {
      //   e.ProjectId = this.ProjectId;
      //   e.Qid = this.Qid;
      // });
      naPai.AddList(params).then(e => {
        this.$message.success('保存成功');
        this.$emit('closeDialog', false);
      });
      console.log(this.nbForm);
    },
    // 查询条件下拉查询 现在  **********************
    getList() {
      this.selectLoading = true;
      smartSearch.GetPageList(this.pageSet).then(e => {
        this.selectLoading = false;
        e.data.Data.rows.forEach(item => {
          console.log(123);
          item.Name = item.Name + '(' + item.System + ')';
        });
        this.options = e.data.Data.rows;
        console.log(e);
      });
    },
    onRestFz() {
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
    },
    toAdd(item, index) {
      this.nbForm.push({
        ConditionalType: '',
        Vaule: '',
        SelectType: '',
        MaxVaule: '',
        MinVaule: '',
        EventConditional: 0
      });
      console.log(this.nbForm, 888);
    },
    // 高级关系
    changeRelation(val, index) {
      const arr = ['Vaule', 'MinVaule', 'MaxVaule', 'EventDay', 'EventDataMappingId', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },
    changeRelations(val, index) {
      const arr = ['EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },
    timeChange(item, index) {
      const arr = ['EventDay', 'EventDataMappingId', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      // this.$set(this.nbForm);
      console.log(item, index);
    },
    toDel(item, index) {
      if (this.nbForm.length === 1) {
        this.nbForm = [
          {
            ConditionalType: '',
            Vaule: '',
            EventConditional: 0
          }
        ];
        return;
      }
      this.nbForm.splice(index, 1);
      console.log(item, index);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 20px !important;
}
.x {
  .div_select {
    padding: 50px;
  }
  .btn {
    padding-bottom: 50px;
  }
}

.form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 50px;
  .demo-form-inline {
    .el-form-item {
      margin-right: 0;
    }
  }
  ::v-deep() {
    .el-form-item {
      margin-right: 10px !important;
    }
  }
}
.nbSearch {
  .nbSearch_child {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 15px;
    & > div:first-child {
      margin-right: 10px;
    }
    ::v-deep() {
      .el-select {
        margin-right: 10px !important;
      }
    }
  }
}
.flexAll {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #409eff;
  cursor: pointer;
}
.flexAll_end {
  height: 100%;
  display: flex;
  align-items: center;
}

.opAndOr {
  width: 100px;
}
.inputChose {
  width: 200px;
  margin-right: 10px;
}
.iconRight {
  margin-right: 5px;
}

.condition {
  color: #333333;
  font-size: 20px;
  padding: 0 8px;
  border-left: 3px solid #3388ff;
}
.czhi {
  /* background: #fff !important; */
}
</style>
